import { mapState } from "vuex";

import { nameRoutes } from "../../router/nameRoutes";

import { getRichieste } from "../../utils/richieste/api";

import N4M from "../../utils/commons";
import LABEL from "../../utils/label";

export const richiesteMixin = {
  data() {
    return {
      LABEL,
      N4M,
      nameRoutes,
      loader: {
        page: true,
      },
      richieste: null,
      errors: {
        alert: null,
      },
      button: {
        action: (element) => {
          this.$router.push({
            name: nameRoutes.RICHIESTA,
            params: {
              idRichiesta: element.id,
            },
          });
        },
        label: () => LABEL.RICHIESTE.MODIFY_REQUEST,
        icon: () => "pen",
      },
    };
  },
  computed: {
    ...mapState("UserDetails", ["userDetails"]),
  },
  methods: {
    setAll: async function () {
      const response = await getRichieste();

      if (response.result === "KO") {
        this.errors.alert = response.code;
        this.loader.page = false;
        return;
      }

      this.richieste = response.data.map((richiesta) => ({
        id: richiesta.idRichiesta,
        label: [{ text: N4M.CONVERTDATE(richiesta.dataRichiesta) }],
        button: true,
        checkbox: false,
      }));

      this.loader.page = false;
    },
  },
  created() {
    this.setAll();
  },
};
